function getComponents(defaultComponents, overrides) {
    const result = {};
    const componentNames = Object.keys(defaultComponents);
    componentNames.forEach((componentName)=>{
        const { component: overridesComponent , props: overridesProps = {}  } = overrides[componentName] || {};
        result[componentName] = {
            component: overridesComponent || defaultComponents[componentName],
            props: {
                ...overridesProps
            }
        };
    });
    return result;
}

export { getComponents };
